<div class="col-12 sm:col-12 md:col-12 lg:col-8 px-0">
    <p-steps [model]="items" [readonly]="false" [activeIndex]="activeIndex"></p-steps>
</div>